// extracted by mini-css-extract-plugin
module.exports = {"container":"_3173e89","header":"_49048a0","closeIcon":"_4a15507","section":"_f40fb91","error":"_219771a","loginForm":"_a7c6cdb","footer":"_4303a47","loading":"_771ad7b"};